import { render } from "./PaginationNews.vue?vue&type=template&id=fc8e397c"
import script from "./PaginationNews.vue?vue&type=script&lang=js"
export * from "./PaginationNews.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__